import {
  ListItem, ListItemText, Box,
  Card,
  CardContent,
  Typography,
  CardActions,
  Button,
  Avatar,
  CardHeader,
  IconButton,
  CardMedia,
  ListItemIcon,
  Collapse,
  List,
  Divider,
} from '@material-ui/core';
import Zoom from '@mui/material/Zoom';

import ModeStandbyIcon from '@mui/icons-material/ModeStandby';
import { Grid, ListItemButton } from '@mui/material';
import styles from "./ListItemProductTag.module.scss";
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { useState } from 'react';
import { ExpandLess, ExpandMore } from '@mui/icons-material';


const ListItemProductTag = ({ tag }) => {

  const [open, setOpen] = useState(false);

  const handleClick = () => {
    setOpen(!open);
  };

  return (<>
    <ListItemButton onClick={handleClick} className={styles["button-list"]}>
      <img src={tag.product?.image} className={styles["image"]} />
      <div className={styles["text"]}>{tag.product?.name}</div>
      <div className={styles["text-end"]}>{tag.sku}</div>
      {open ? <ExpandLess /> : <ExpandMore />}
    </ListItemButton>
    <Collapse in={open} timeout="auto" unmountOnExit>

      {tag.epc &&
        <ListItemButton sx={{ pl: 3 }}>
          <ListItemText  primary={"EPC: " + tag.epc} />
        </ListItemButton>
      }
      {tag.epcs &&
        tag.epcs.map((tag, index) => {
          return (
            <>
              <Grid index={index} container spacing={1}>
                <Grid item xs={12}   >
                  <ListItemText primary={tag} sx={{ marginLeft: '15px' }} />
                </Grid>
              </Grid>
              <Divider />
            </>
          )
        })
      }
    </Collapse>
  </>

  );
}

export default ListItemProductTag;